import Home from '../containers/Home'

export class Route {
    path: string
    component: any
    _private: boolean
    children: Route[]
    redirectTo: string
    props?: any

    constructor(
        path: string,
        component: any,
        _private: boolean,
        redirectTo: string,
        children: Route[],
        props?: any
    ) {
        this.path = path
        this.component = component
        this._private = _private
        this.children = children
        this.redirectTo = redirectTo
        this.props = props ? props : undefined
    }

    static DefaultRoute() {
        return new Route('/home', Home, false, null, [])
    }

    child(child: Route) {
        this.children.push(child)
        return this
    }

    _children(children: Route[]) {
        this.children.concat(children)
        return this
    }
}
